import { useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { getActasPublicas, useActas } from '../../../../../appStore/actas';
import { useConcurso } from '../../../../../providers/ConcursoProvider';
import { CommonRoot } from '../../../../CompUtils/CommonRoot';
import FullLoading from '../../../../CompUtils/FullLoading';
import { ActaPublicaFila } from './ActaPublicaFila';

const ListadoActasPublicas = (props) => {
  const dispatch = useDispatch();
  const { actasPublicas, loading } = useActas();
  const { idLlamadoConcurso } = useConcurso();
  useEffect(() => {
    dispatch(getActasPublicas({ idLlamadoConcurso }));
  }, [dispatch, idLlamadoConcurso]);
  return (
    <>
      <CommonRoot>
        <FullLoading show={actasPublicas ? loading : false} />

        {(actasPublicas == null || actasPublicas == 'undefined') && (
          <Alert variant="danger">No se obtuvieron las actas</Alert>
        )}
        {actasPublicas && (
          <table className="table">
            <colgroup>
              <col style={{ width: '40%' }} />
              <col style={{ width: '20%' }} />
            </colgroup>
            <thead>
              <tr>
                <th>Acta</th>
                <th>Ver</th>
              </tr>
            </thead>
            <tbody>
              {actasPublicas?.map((e) => (
                <ActaPublicaFila key={e.idActaConcurso} {...e} />
              ))}
            </tbody>
          </table>
        )}
      </CommonRoot>
    </>
  );
};

export default ListadoActasPublicas;
